<div mat-dialog-content>
  <div *ngIf="data.title" class="mb-4">{{data.title}}</div>
  <div class="d-flex justify-content-center">
    <svg-icon name="spinner" class="icon icon-lg"></svg-icon>
  </div>
</div>
